
export class appointmentCount {
    cancellationreq?: number = 0
    confirmed?: number = 0
    myown?: number = 0
    newc?: number = 0
    pending?: number = 0
}